import background from './background';
import text from './text';

export default {
  background,
  text,
};
